module.exports = __webpack_public_path__ + "img/15.c8261a53.jpg";